import { render } from "./App.vue?vue&type=template&id=322c86be"
const script = {}

import exportComponent from "/var/www/oralhealthmap.uz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__